import React from 'react';
import { Box } from '@mui/material';

/**
 * CRT terminal-style section heading.
 * Renders as: > TITLE  with a 2px green left border.
 *
 * Spec (from ../jeeves/docs/style-guide.md):
 *   h2.section {
 *     font-family: var(--font-head); font-size: 10px;
 *     color: var(--text-dim); letter-spacing: 0.1em;
 *     padding-left: 12px; border-left: 2px solid var(--primary);
 *   }
 */
interface SectionTitleProps {
  children: React.ReactNode;
  sub?: React.ReactNode;
  sx?: any;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ children, sub, sx }) => {
  const title =
    typeof children === 'string' ? children.toUpperCase() : children;
  return (
    <Box sx={{ mb: 2, ...sx }}>
      <Box
        component="h2"
        sx={{
          m: 0,
          pl: '12px',
          borderLeft: '2px solid var(--crt-green)',
          fontFamily: "'Press Start 2P', monospace",
          fontSize: '10px',
          color: 'var(--crt-dim)',
          letterSpacing: '0.1em',
          fontWeight: 'normal',
          lineHeight: 1.4,
          textShadow: '0 0 6px rgba(0, 255, 65, 0.35)',
        }}
      >
        &gt; {title}
      </Box>
      {sub && (
        <Box
          sx={{
            mt: 1,
            pl: '14px',
            fontFamily: "'VT323', monospace",
            fontSize: '16px',
            color: 'var(--crt-dim)',
          }}
        >
          {sub}
        </Box>
      )}
    </Box>
  );
};

export default SectionTitle;
